import * as Yup from 'yup'

import { isAgeObjectContinuousRange } from '../../../../lineItemHelpers'

import {
  AGE_OPTION,
  ANYONE_OVER_18,
  CUSTOM_AGE_OPTION,
  CUSTOM_AGE_RANGES
} from '../../../../../ReusableFormFields/AgeRangesFields/fields'
import { dv360CustomAgeRangesInitialValues } from '../../../../fields'

export const initialValues = {
  [CUSTOM_AGE_RANGES]: dv360CustomAgeRangesInitialValues,
  [AGE_OPTION]: ANYONE_OVER_18
}

export const customAgeRangesValidation = {
  name: 'Custom age range validation',
  test: (ageObject, context) => {
    const selectedAgeRanges = Object.keys(ageObject).filter(ageItem => ageObject[ageItem])
    if (!selectedAgeRanges.length) {
      return context.createError({
        message: 'Select at least one age range',
        path: CUSTOM_AGE_RANGES
      })
    }

    if (!isAgeObjectContinuousRange(ageObject)) {
      return context.createError({
        message: 'Please select continuous range of ages',
        path: CUSTOM_AGE_RANGES
      })
    }

    return true
  }
}

export const validationSchema = Yup.object({
  [CUSTOM_AGE_RANGES]: Yup.object().when(AGE_OPTION, {
    is: CUSTOM_AGE_OPTION,
    then: () => Yup.object().test(customAgeRangesValidation)
  })
})
